import { createComponentPreviewEntry } from '@wix/editor-elements-integrations';
import { withComponentPreview } from '@wix/editor-elements-preview-utils';
import React from 'react';
import { WFacebookCommentProps } from '../WFacebookComment.types';

export default (ViewerComponent: React.ComponentType<WFacebookCommentProps>) =>
  createComponentPreviewEntry(withComponentPreview(ViewerComponent));
